/** Planning Phase 3 P3-6b (plan D-294): rentetan panel rujukan luar, carian, pengambilan dan himpunan OSC. */
export default {
  osc: {
    ids: {
      otherScheme: 'Skema lain…',
      customScheme: 'Id skema',
      issuerFromSettings: 'Lalai kepada kod majlis {{pbt}} daripada Tetapan → Perancangan.',
      issuerMissing: 'Tiada kod majlis dalam Tetapan → Perancangan: taip siapa yang mengeluarkan id ini.',
      patternWarning: 'Ini tidak seperti {{scheme}} yang biasa. Semak dengan OSC; ia masih boleh dipautkan.',
      linkedWithWarning: 'Dipautkan, tetapi ia tidak seperti id biasa jenisnya. Semak dengan OSC.',
      multi: 'boleh menamakan beberapa permohonan',
      unlink: 'Buang pautan',
      unlinkLabel: 'Buang pautan {{value}}',
      unlinkTitle: 'Buang pautan rujukan ini',
      unlinkBody: 'Rujukan {{value}} dibuang daripada permohonan ini. Sejarahnya menyimpan pautan dan sebab anda.',
      reason: 'Sebab',
      reasonHint: 'Disimpan dalam sejarah kes; pemohon tidak melihatnya.',
      reasonRequired: 'Berikan sebab.',
      confirm: 'Buang pautannya',
      cancel: 'Kekalkan',
    },
    search: {
      label: 'Rujukan luar',
      placeholder: 'Nombor OSC, tepat seperti yang direkodkan',
      submit: 'Cari',
      clear: 'Kosongkan rujukan',
      active: 'Permohonan yang dipautkan kepada {{value}}',
      landmark: 'Cari mengikut rujukan luar',
    },
    intake: {
      title: 'Dokumen daripada OSC',
      intro: 'Ambil masuk PDF permohonan daripada OSC 3.0 Plus, satu atau beberapa sekali gus.',
      choose: 'Pilih PDF',
      type: 'Jenis dokumen bagi {{name}}',
      upload: 'Ambil masuk',
      progress: 'Mengambil masuk {{done}} daripada {{total}}…',
      done: 'Telah diambil masuk.',
      failed: 'Tidak diambil masuk. Semak fail dan cuba lagi.',
      remove: 'Buang {{name}}',
      retry: 'Cuba lagi',
      retryLabel: 'Cuba lagi: {{name}}',
    },
    bundle: {
      title: 'Himpunan OSC',
      intro:
        'Apa yang perlu dimasukkan ke OSC 3.0 Plus: helaian kemasukan, senarai semak dan PDF. Tiada apa dihantar ke OSC dari sini.',
      prepare: 'Sediakan himpunan',
      refresh: 'Sediakan semula',
      download: 'Muat turun himpunan (zip)',
      progress: 'Mengambil {{done}} daripada {{total}} PDF…',
      failed: 'Himpunan tidak dapat dibina. Cuba lagi.',
      header: 'Permohonan',
      caseRef: 'Rujukan',
      stage: 'Langkah semasa',
      checklist: 'Telah disalin ke OSC',
      checklistHint: 'Tandakan perkara setelah dimasukkan ke OSC. Hanya pegawai majlis ini melihat tanda tersebut.',
      markLabel: 'Telah disalin: {{item}}',
      entrySheet: 'Helaian kemasukan',
      documents: 'PDF untuk OSC',
      noDocuments: 'Tiada PDF untuk disalin ke OSC.',
      excluded: 'Tidak dimasukkan dalam himpunan',
      marking: 'Menyimpan…',
      withdrawn: 'Rujukan ditarik balik',
      withdrawnWithAgency: 'Rujukan kepada {{agency}} ditarik balik',
      referralKinds: { internal: 'Jabatan majlis', external: 'Agensi luar' },
      referralStatuses: { open: 'Terbuka', answered: 'Dijawab', withdrawn: 'Ditarik balik' },
      yes: 'Ya',
      no: 'Tidak',
      kinds: {
        transition: 'Langkah',
        referral_requested: 'Rujukan dihantar',
        referral_answered: 'Rujukan dijawab',
        document: 'Dokumen',
      },
      kindsWithAgency: {
        referral_requested: 'Rujukan dihantar kepada {{agency}}',
        referral_answered: 'Rujukan dijawab oleh {{agency}}',
      },
      reasons: { too_large: 'melebihi 10 MB: OSC menolaknya', not_pdf: 'bukan PDF', inbound: 'datang daripada OSC' },
      outcomes: {
        requirements: 'Ada keperluan',
        no_requirements: 'Tiada keperluan',
        deemed: 'Tiada jawapan (dianggap)',
      },
      fields: {
        agency: 'Agensi',
        kind: 'Dalaman atau luar',
        requestedOn: 'Dirujuk pada',
        dueOn: 'Tarikh akhir',
        outcome: 'Jawapan',
        answeredOn: 'Dijawab pada',
        late: 'Lewat',
        conditions: 'Bilangan keperluan',
        pCodes: 'Peringkat pematuhan',
        docType: 'Jenis dokumen',
        file: 'Fail dalam himpunan',
        size: 'Saiz (bait)',
        revision: 'Semakan',
        status: 'Status permintaan',
      },
      csv: {
        item: 'Perkara',
        screen: 'Skrin OSC',
        field: 'Medan',
        value: 'Nilai',
        date: 'Tarikh',
        mirrored: 'Telah disalin ke OSC',
      },
    },
  },
} as const
